var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0859 26.3226C23.4866 26.3226 31.0859 20.33 31.0859 16.1613C31.0859 11.9925 23.4866 6 16.0859 6C8.82706 6 1.08594 12.2268 1.08594 16.1613C1.08594 20.0958 8.82706 26.3226 16.0859 26.3226Z",
    stroke: "#1CB0F6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0863 19.5484C17.957 19.5484 19.4734 18.0319 19.4734 16.1613C19.4734 14.2907 17.957 12.7742 16.0863 12.7742C14.2157 12.7742 12.6992 14.2907 12.6992 16.1613C12.6992 18.0319 14.2157 19.5484 16.0863 19.5484Z",
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0852 22.4516C19.5593 22.4516 22.3756 19.6353 22.3756 16.1613C22.3756 12.6872 19.5593 9.87097 16.0852 9.87097C12.6112 9.87097 9.79492 12.6872 9.79492 16.1613C9.79492 19.6353 12.6112 22.4516 16.0852 22.4516Z",
    stroke: "#1CB0F6",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0859375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputShowPassword);
export default __webpack_public_path__ + "static/media/input-show-password.bdc3ed15704d831c74e7b95f898361b5.svg";
export { ForwardRef as ReactComponent };